import React, { useEffect, useRef, useState } from 'react';


import hamburgerIcon from '../assets/icons/menu.svg';
import closeIcon from '../assets/icons/XMark.svg';



const handleScroll = (event, targetId) => {
  event.preventDefault();
  const targetElement = document.getElementById(targetId);
  if (targetElement) {
    targetElement.scrollIntoView({ behavior: 'smooth' });
  }
};
const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [navVisible, setNavVisible] = useState(true);
  const lastScrollY = useRef(0);

  useEffect(() => {
    const updateNavbarVisibility = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY <= 0 || currentScrollY < lastScrollY.current) {
        setNavVisible(true);
      } else if (currentScrollY > lastScrollY.current) {
        setNavVisible(false);
        setMenuOpen(false);
      }

      lastScrollY.current = currentScrollY;
    };

    window.addEventListener('scroll', updateNavbarVisibility, { passive: true });
    return () => window.removeEventListener('scroll', updateNavbarVisibility);
  }, []);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <nav
      className={`bg-navy py-4 fixed top-0 left-0 w-full z-50 border-b border-white/10 transition-all duration-300 ease-in-out ${
        navVisible ? 'translate-y-0 opacity-100' : '-translate-y-full opacity-0'
      }`}
    >
      <div className="container mx-auto flex justify-between items-center px-4 md:px-8">
        {/* Responsive Company Name */}
        <span className="shrink-0 leading-none font-sans text-white font-semibold text-base md:text-lg lg:text-xl tracking-wide">
          <a href="#hero" onClick={(e) => handleScroll(e, 'hero')} className="hover:text-gold-light">
            <span className="md:hidden">McLean Insurance Brokers & Risk Solutions Ltd.</span>
            <span className="hidden md:inline">McLean Insurance Brokers & Risk Solutions Ltd.</span>
          </a>
        </span>

        {/* Menu Links for Larger Screens */}
        <div className="hidden md:flex md:items-center md:space-x-8" id="menu">
          <a href="#about" className="leading-none text-white hover:text-gold-light font-medium" onClick={(e) => handleScroll(e, 'about')}>
            About
          </a>

          <a href="#solutions" className="leading-none text-white hover:text-gold-light font-medium" onClick={(e) => handleScroll(e, 'solutions')}>
            Services
          </a>
          <a href="#contact" className="leading-none text-white hover:text-gold-light font-medium" onClick={(e) => handleScroll(e, 'contact')}>
            Contact
          </a>
        </div>

        {/* Hamburger Icon for Mobile */}
        <div className="flex items-center md:hidden">
          <button onClick={toggleMenu} className="text-white focus:outline-none">
            {/* Hamburger Icon */}
            {!menuOpen ? (
              <img
                id="hamburger-icon"
                src={hamburgerIcon}
                alt="Open Menu"
                className="h-8 w-8 filter invert brightness-0"
              />
            ) : (
              <img
                id="close-icon"
                src = {closeIcon}
                alt="Close Menu"
                className="h-8 w-8 filter invert brightness-0"
              />
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        id="mobile-menu"
        className={`md:hidden flex flex-col justify-center items-center h-screen bg-navy text-white space-y-6 ${menuOpen ? '' : 'hidden'}`}
      >
        <a
          href="#about"
          className="hover:text-gold-light close-menu text-2xl font-medium"
          onClick={(e) => { handleScroll(e, 'about'); closeMenu(); }}
        >
          About
        </a>
        <a
          href="#solutions"
          className="hover:text-gold-light close-menu text-2xl font-medium"
          onClick={(e) => { handleScroll(e, 'solutions'); closeMenu(); }}
        >
          Services
        </a>
        <a
          href="#contact"
          className="hover:text-gold-light close-menu text-2xl font-medium"
          onClick={(e) => { handleScroll(e, 'contact'); closeMenu(); }}
        >
          Contact
        </a>
        <a
          href="#inquiry"
          className="bg-gold hover:bg-gold-light text-navy-dark text-lg font-semibold uppercase tracking-wider px-6 py-3"
          onClick={(e) => { handleScroll(e, 'inquiry'); closeMenu(); }}
        >
          Send an Inquiry
        </a>
      </div>
    </nav>
  );
};

export default Navbar;
